module.exports = __webpack_public_path__ + "assets/lawandorder-3.fcbd4d6d.svg";